import voteReportApi from '~/clientApis/reportApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { GetUserVoteCountRequest } from '~/definitions/report';
import { getStore } from '~/mobx/AppStore';

export const getUserVoteCount = async () => {
    const { electionMenuStore, companyStore, regionStore, reportStore, generalSettingsStore } = getStore();

    reportStore.setIsGettingUserVoteCount(true);

    let requestParams;
    if (electionMenuStore.isCompanyLevel) {
        requestParams = {
            group_by: 'company' as GetUserVoteCountRequest['group_by'],
            company_id: companyStore.selectedSlagId,
            year: generalSettingsStore.getSelectedElectionYear(),
        };
    } else {
        requestParams = {
            group_by: 'region' as GetUserVoteCountRequest['group_by'],
            company_id: companyStore.selectedSlagId,
            election_id: generalSettingsStore.selectedElectionId,
            region_id: regionStore.selectedRegionId,
            year: generalSettingsStore.getSelectedElectionYear(),
        };
    }

    try {
        const response = await voteReportApi.getUserVoteCount(requestParams);
        const data = response?.data?.[0];
        reportStore.setUserVoteCount(data?.user_count);
        reportStore.setTotalUserCount(data?.total_user_count);
    } catch (error) {
        const errorMessage = (await (error as Response).json()).error || 'Error fetching user vote count';
        showMessageModal('error', errorMessage);
    } finally {
        reportStore.setIsGettingUserVoteCount(false);
    }
};
